import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
// import Keycloak from 'keycloak-js';
import App from './App';
import { keycloak, initOptions } from './config/keycloak';
import { resetContext, Provider } from 'kea';
import dayjs from 'dayjs';
import './muistyleoverides.css';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
var duration = require('dayjs/plugin/duration')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)
serviceWorker.unregister();

resetContext({
	createStore: true,
	plugins: [
		// additional kea plugins
	],
})

keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {

	if (!auth) {
		window.location.reload();
	} else {
		console.info("Authenticated");
	}

	//React Render

	ReactDOM.render((
		<BrowserRouter>
			<Provider>
				<App />
			</Provider>
		</BrowserRouter>
	), document.getElementById('root'));

	localStorage.setItem("react-token", keycloak.token);
	localStorage.setItem("react-refresh-token", keycloak.refreshToken);
	// keycloak.onTokenExpired = () => {
	// 	console.log('expired ' + new Date());
	// 	keycloak.updateToken(70).success((refreshed) => {
	// 		if (refreshed) {
	// 			console.log('refreshed ' + new Date());
	// 		} else {
	// 			console.log('not refreshed ' + new Date());
	// 		}
	// 	}).error(() => {
	// 		console.error('Failed to refresh token ' + new Date());
	// 	});
	// }

	setInterval(() => {
		keycloak.updateToken(70).then((refreshed) => {
			// console.log(refreshed);
			if (refreshed) {
				console.debug('Token refreshed' + refreshed);
			} else {
				console.warn('Token not refreshed, valid for '
					+ Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
			}
		}).catch(() => {
			console.error('Failed to refresh the token, or the session has expired');
		});
	}, 50000)

}).catch((err) => {
	console.error(err);
});
